/**
 * Sistema de capas (z-index) centralizado.
 *
 * Mantine asigna sus propios z-index a Modal, Drawer, Notifications, Tooltip
 * via CSS variables (--mantine-z-index-*). Cuando agregamos overlays propios,
 * conviene usar estas constantes para garantizar el orden visual correcto
 * y evitar el clasico "mi modal queda detras del toast".
 *
 * Escala mental:
 *   1-10     · contenido en flujo
 *   100-200  · navigation (sticky header, sidebar)
 *   300-500  · overlays contextuales (popovers, dropdowns, command palette)
 *   1000+    · overlays modales (dialog, drawer)
 *   2000+    · notificaciones globales (toast, system banner)
 *   9999     · debugging only · NUNCA dejar en prod
 */
export const Z_INDEX = {
  /** Contenido decorativo de fondo (orbes, gradientes) · siempre detras. */
  background: 0,
  /** Contenido en flujo normal del documento. */
  content: 1,
  /** Elementos sticky no-overlay (table headers, section labels). */
  sticky: 100,
  /** Header del AppShell · debajo de modales pero arriba del contenido. */
  appHeader: 200,
  /** Navbar/sidebar fijo. */
  appNavbar: 200,
  /** Popovers y dropdowns contextuales. */
  popover: 300,
  /** Command palette (Ctrl+K). */
  commandPalette: 400,
  /** Tooltips · arriba de popovers para que sean siempre visibles. */
  tooltip: 500,
  /** Modal/Dialog backdrop. */
  modalBackdrop: 1000,
  /** Modal/Dialog content · arriba del backdrop. */
  modal: 1001,
  /** Drawer (slide-in panels). */
  drawer: 1100,
  /** Notificaciones globales (toasts) · siempre encima de todo lo demas. */
  notification: 2000,
} as const;

export type ZIndexKey = keyof typeof Z_INDEX;
